import React from 'react';

import DateLabel from '@atlaskit/date-label';

export default function DateLabelWarning(): React.JSX.Element {
	return <DateLabel label="29 Jul 2026" appearance="warning" />;
}
